import { ChevronRight } from '@aktiia/design-system';
import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { FetchStatus, ModalName } from '../../../../enums';
import { useOpenModal } from '../../../../features/modals';
import {
  useOrganization,
  useOrganizationDevicesTableHeaders,
  useOrganizationDevicesTableRows,
} from '../../../../features/organization';
import { Button, Card } from '../../../common';
import { Table } from '../../table';
import { NoDevices, OrganizationDevicesHeader } from './components';
import { IOrganizationDevicesProps } from './types';

export const OrganizationDevices = ({ expanded }: IOrganizationDevicesProps) => {
  const { t } = useTranslation();
  const {
    status: { fetchDevices: status },
  } = useOrganization();
  const deviceRows = useOrganizationDevicesTableRows(!expanded);
  const header = useOrganizationDevicesTableHeaders(expanded);
  const openContactSupportModal = useOpenModal(ModalName.CONTACT_SUPPORT);
  const loaded = useMemo(() => [FetchStatus.SUCCESS, FetchStatus.FAILURE].includes(status), [status]);

  return (
    <Card>
      <div className="mb-6">
        <OrganizationDevicesHeader expanded={expanded} />
        {expanded && (
          <p className="typography-paragraph-3 text-text-secondary mt-2">{t('organization.subtitle.devices')}</p>
        )}
      </div>

      {loaded && !deviceRows.length ? (
        <NoDevices expanded={expanded} />
      ) : (
        <Table rows={deviceRows} header={header} loading={!loaded} />
      )}

      <div className="grow" />
      <div className="mt-6">
        {expanded ? (
          <span className="typography-paragraph-3 text-text-tertiary">
            <Trans
              i18nKey="organization.devices.description.support"
              components={[
                <span
                  key="span"
                  className="typography-inline-link-3 text-text-link cursor-pointer"
                  onClick={() => openContactSupportModal()}
                />,
              ]}
            />
          </span>
        ) : (
          <Button
            text={t('organization.button.devices')}
            path="/app/organization/devices"
            rightIcon={<ChevronRight />}
            type="tertiary"
          />
        )}
      </div>
    </Card>
  );
};
